<script setup lang="ts">
import { usePwa } from '@/composables/usePwa';
import { ref, computed, onMounted } from 'vue';
const { installEvent, updateReady, install, applyUpdate } = usePwa();
const dismissed = ref(true);
onMounted(() => {
  try { dismissed.value = localStorage.getItem('sst-pwa-install-dismissed') === '1'; } catch { dismissed.value = false; }
});
const inTelegram = computed(() => Boolean(typeof window !== 'undefined' && window.Telegram?.WebApp?.initData));
function dismiss() {
  try { localStorage.setItem('sst-pwa-install-dismissed', '1'); } catch { /* приватный режим */ }
  dismissed.value = true;
}
</script>
<template>
  <div v-if="updateReady" class="pwa-bar" role="status"><span>Доступна новая версия портала.</span><button class="outline-button press" @click="applyUpdate">Обновить</button></div>
  <div v-else-if="installEvent && !dismissed && !inTelegram" class="pwa-bar" role="status"><span>Установите портал на телефон — откроется одним касанием.</span><div class="event-actions"><button class="primary-button press" @click="install">Установить</button><button class="text-button" @click="dismiss">Не сейчас</button></div></div>
</template>
